export const EXCLUDED_DEFAULT_EVENT_ATTRIBUTE_TYPES = new Set([
  'number',
  'checkbox',
  'personnel',
]);

export const isDefaultEventAttributeType = attr =>
  !EXCLUDED_DEFAULT_EVENT_ATTRIBUTE_TYPES.has(attr.attribute_display_type);
